const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const responseBodyMessage = (error: unknown): string | undefined => {
  const response = isObject(error) ? error.response : undefined;
  const data = isObject(response) ? response.data : undefined;
  const message = isObject(data) ? data.message : undefined;
  return typeof message === "string" && message ? message : undefined;
};

/** The backend's response body message for an Amplify API error, else the Error message. */
export const getApiErrorMessage = (error: unknown, fallback: string): string =>
  responseBodyMessage(error) || (error instanceof Error && error.message ? error.message : fallback);
